import React from "react";

import Button from "@material-ui/core/Button";
import KeyboardReturnIcon from "@material-ui/icons/KeyboardReturn";
import CloudDoneIcon from "@material-ui/icons/CloudDone";

const ButtonErp = ({
  label,
  save,
  cancel,
  startIcon,
  onClick = () => {},
  className,
  ...props
}) => {
  return (
    <Button
      {...props}
      variant="contained"
      color={save ? "primary" : "default"}
      startIcon={startIcon || save ? <CloudDoneIcon /> : <KeyboardReturnIcon />}
      onClick={onClick}
      className={cancel && !className ? "btn-cancelar" : className}
    >
      {label || save ? label || "Salvar" : "Cancelar"}
    </Button>
  );
};

export default ButtonErp;
